import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  IconButton,
  Collapse,
  Box,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";


// flag type describe
export type FlagType = {
  _id: string;
  awbNumber: string;
  flagName: string;
  leg: string;
  type: string;
  isActionTaken: boolean;
  actions: ActionType[];
  createdAt: string;
  updatedAt: string;
};

// action type 
type ActionType = {
  _id: string;
  flagShipmentId: string;
  textMessage: string;
  attachment: string;
  trackingNumber: string;
  isViewable: boolean;
  createdAt: string;
  updatedAt: string;
};

type RowProps = {
  row: ActionType[];
  index: number;
};
interface TabularViewofFlagListProps {
  flags?: FlagType[];
}

const TabularViewofFlagList = ({ flags }: TabularViewofFlagListProps) => {
  let sn = 0


  function formatDateToDDMMYYYY(isoString: string) {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const Row = ({ row, index }: RowProps) => {
    const [open, setOpen] = useState(false);

    return (
      <>
        <>
          {
            index > 0 ? (
              <>
                {/* Top Row */}
                <TableRow sx={{ "& td": { border: "none", p: 0, pt: 1 } }}>
                  <TableCell align="right" sx={{ width: 50 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center"
                      }}
                    >
                      {!open && (
                        <>
                          <span style={{ marginRight: 8 }}>{index}</span>
                          <IconButton
                            size="small"
                            onClick={() => setOpen(true)}
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>

                {/* Collapsible Row */}
                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{
                      border: "none",
                      p: 0,
                      position: "relative"   // important
                    }}
                  >
                    {/* Arrow Right Middle When Open */}
                    {open && (
                      <IconButton
                        size="small"
                        onClick={() => setOpen(false)}
                        sx={{
                          position: "absolute",
                          right: -35,
                          top: "50%",
                          transform: "translateY(-50%)",
                          backgroundColor: "#fff",
                          boxShadow: 1,
                          zIndex: 10
                        }}
                      >
                        <KeyboardArrowUpIcon />
                      </IconButton>
                    )}

                    <Collapse in={open} timeout="auto" unmountOnExit>
                      <Box m={2}>
                        <Table size="small" className="innerTable">
                          <TableHead>
                            <TableRow sx={{ "& th": { border: "none" } }}>
                              <TableCell>S.No</TableCell>
                              <TableCell>Action</TableCell>
                              <TableCell>Date</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {row?.map((action, i) => (
                              <TableRow
                                key={i}
                                sx={{
                                  backgroundColor: "#f7f7f7",
                                  "& td": { border: "none", p: 0, pt: 1 }
                                }}
                              >
                                <TableCell>
                                  {i+1}
                                </TableCell>
                                <TableCell>
                                  {action?.textMessage}
                                </TableCell>
                                <TableCell>
                                  {formatDateToDDMMYYYY(action?.updatedAt)}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ) : "No Action Taken Yet"
          }
        </>

      </>
    );
  };

  return (
    <>

      <div className="listEventsTableResponsiive" style={{ marginTop: '12px' }}>
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader >
            <TableHead >
              <TableRow>
                <TableCell>Sno</TableCell>
                <TableCell>Flag</TableCell>
                <TableCell>Impacted Leg</TableCell>
                {/* <TableCell>Date Reported</TableCell> */}
                <TableCell>Action taken </TableCell>
              </TableRow>
            </TableHead>
            <TableBody >
              {(flags || []).map((row: FlagType, i: number) => {
                const id = i + 1;
                sn++;
                return (

                  <TableRow key={id}>
                    <TableCell>{sn}</TableCell>
                    <TableCell>{row?.flagName}</TableCell>
                    {/* <TableCell>{row?.milestoneType}</TableCell> */}
                    <TableCell>{row?.leg}</TableCell>
                    <TableCell sx={{ borderBottom: "none", padding: 0 }}> <Row row={row?.actions} index={row?.actions?.length} /></TableCell>
                    {/* <TableCell>{row?.textMessage}</TableCell> */}
                  </TableRow>

                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>


  )
}


export default TabularViewofFlagList;

